import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { foundingPromo } from '../../data/foundingOffer';

/** Founding Member offer panel shown above the membership plans. */
export function FoundingOfferBanner() {
  return <section aria-labelledby="founding-promo-heading" className="rounded-[2rem] bg-purple-800 px-7 py-9 md:px-12 md:py-11 text-white" data-id="element-454" data-mp="3sglz5ykk0ayy">
      <div className="grid gap-9 lg:grid-cols-[1.35fr_1fr] lg:items-center lg:gap-14" data-id="element-455" data-mp="68m0js3ieift">
        <div data-id="element-456" data-mp="6agpriltcwpp">
          <p className="inline-flex items-center gap-2 text-sm font-medium text-purple-200" data-id="element-457" data-mp="19sycvtoaduy">
            <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-458" data-mp="f9broihtrkn7" />
            Founding Member offer
          </p>
          <h2 id="founding-promo-heading" className="mt-4 font-serif text-3xl md:text-4xl leading-[1.15] text-white" data-id="element-459" data-mp="a9ph6gtdsii3">
            {foundingPromo.headline}
          </h2>
          <p className="mt-5 max-w-xl text-base text-purple-100 leading-relaxed" data-id="element-460" data-mp="2c23u11h2iwrn">{foundingPromo.body}</p>
        </div>

        <ol aria-label="How billing works" className="rounded-2xl bg-white/10 divide-y divide-white/15" data-id="element-461" data-mp="1hrw9wdgi13eh">
          <li className="flex items-center justify-between gap-6 px-6 py-5" data-id="element-462" data-mp="1mqpqwfuzvcje">
            <span className="text-sm text-purple-100" data-id="element-463" data-mp="1ror6gqt7otq4">Months 1–2</span>
            <span className="text-right" data-id="element-464" data-mp="1wfr4y0hzbjuq">
              <span className="block font-serif text-3xl leading-none text-white" data-id="element-465" data-mp="1wgsoktd29eo2">$0</span>
              <span className="mt-1.5 block text-xs text-purple-200" data-id="element-466" data-mp="20gb0izmwmfer">Complimentary</span>
            </span>
          </li>
          <li className="flex items-center justify-between gap-6 px-6 py-5" data-id="element-467" data-mp="25eumh01hzr74">
            <span className="text-sm text-purple-100" data-id="element-468" data-mp="2agk08ng3uiyw">Month 3 onward</span>
            <span className="text-right" data-id="element-469" data-mp="2febuvp84wj6s">
              <span className="block font-serif text-xl leading-tight text-white" data-id="element-470" data-mp="2fe3evogpsxrd">Your regular rate</span>
              <span className="mt-1.5 block text-xs text-purple-200" data-id="element-471" data-mp="g32dh2nixq4x">Locked in while active</span>
            </span>
          </li>
        </ol>
      </div>
    </section>;
}